var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedThumbsUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 282.5,
    height: 194.99,
    viewBox: "0 0 282.5 194.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee3d4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2212f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_31872",
    "data-name": "Group 31872",
    transform: "translate(6.03 -15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31486",
    "data-name": "Group 31486",
    transform: "translate(72.403 15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11664",
    "data-name": "Path 11664",
    d: "M276.772,68.148a16.144,16.144,0,0,0-3.558-6.139c-12.633-18.4-41.859-7.743-84.386,4.311-7.11,2.019-5.638-7.528-8.79-26.512-2.06-12.345-15.347-28.166-28.252-24.181C130.519,22.2,156.139,32.578,150.1,79.69c-3.237,25.173-29.507,19.753-22.66,41.918l15.6,50.458c2.666,8.628,6.08,16.66,18.693,14.255,12.225-2.328,12.157,6.877,29.2,1.61l85.328-26.377a16.479,16.479,0,0,0,10.909-20.564,16.246,16.246,0,0,0-6.236-8.479,16.162,16.162,0,0,0-2.319-24.617,16.261,16.261,0,0,0-4-25.767,16.285,16.285,0,0,0,2.16-13.979Z",
    transform: "translate(-126.307 -15)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11666",
    "data-name": "Path 11666",
    d: "M126.991,253.019l-26.562,8.207a6.972,6.972,0,0,1-8.711-4.6L67.31,177.688a6.977,6.977,0,0,1,4.6-8.722l26.574-8.2a6.973,6.973,0,0,1,8.711,4.591l24.4,78.936a6.976,6.976,0,0,1-4.6,8.722Z",
    transform: "translate(-29.747 -59.25)",
    fill: "#cb1522"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11667",
    "data-name": "Path 11667",
    d: "M455.853,180.927a5.924,5.924,0,1,1-.45-2.268A5.927,5.927,0,0,1,455.853,180.927Z",
    transform: "translate(-252.059 23.137)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11668",
    "data-name": "Path 11668",
    d: "M383.927,39.772a4.162,4.162,0,1,1-2.943,1.219A4.161,4.161,0,0,1,383.927,39.772Zm0-1.772a5.926,5.926,0,1,0,4.19,1.735A5.926,5.926,0,0,0,383.927,38Z",
    transform: "translate(-156.425 -9.368)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11669",
    "data-name": "Path 11669",
    d: "M96.892,80.66a6.235,6.235,0,1,1-4.4,1.826A6.232,6.232,0,0,1,96.892,80.66Zm0-2.66a8.89,8.89,0,1,0,6.285,2.6A8.889,8.889,0,0,0,96.892,78Z",
    transform: "translate(-75.639 -1.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11671",
    "data-name": "Path 11671",
    d: "M10.478,9.024l5.707-.014-5.111,2.543a1.907,1.907,0,0,0-1.05,1.834l.589,8.489L7.332,14.019A1.9,1.9,0,0,0,5.58,12.849L0,12.837l4.984-2.51A1.905,1.905,0,0,0,6.031,8.5L5.439,0,8.72,7.853a1.9,1.9,0,0,0,1.758,1.171Z",
    transform: "translate(234.979 48.484) rotate(16)",
    fill: "#ee3d4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11672",
    "data-name": "Path 11672",
    d: "M12.317,11.66l5.468,3.417-6.417-.638a2.144,2.144,0,0,0-2.106,1.124L4.719,24.035,6.3,14.545a2.15,2.15,0,0,0-.972-2.172L0,9.008,6.276,9.6a2.152,2.152,0,0,0,2.1-1.124L12.918,0,11.333,9.482a2.154,2.154,0,0,0,.984,2.178Z",
    transform: "translate(-6.03 163.379) rotate(-20)",
    fill: "#ee3d4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11673",
    "data-name": "Path 11673",
    d: "M11.031,10.341l5.029,2.7-5.706-.188A1.9,1.9,0,0,0,8.56,13.967L5.043,21.716l.847-8.475A1.908,1.908,0,0,0,4.9,11.379L0,8.712l5.578.158A1.9,1.9,0,0,0,7.365,7.755L10.884,0l-.847,8.472a1.906,1.906,0,0,0,.995,1.869Z",
    transform: "translate(255.046 152.171) rotate(-16)",
    fill: "#ee3d4a"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedThumbsUp);
export default __webpack_public_path__ + "static/media/red_thumbs_up.6f22534b613fa69f92396788445f4cd8.svg";
export { ForwardRef as ReactComponent };